import { Box } from '@mui/material';
import { TranscriptionEditModeAction } from '../actions/TranscriptionEditModeAction';
import { TranscriptionSearchToggleAction } from '../actions/TranscriptionSearchToggleAction';
import { TranscriptionSyncAction } from '../actions/TranscriptionSyncAction';
import { TranscriptionWordEfficiencyAction } from '../actions/TranscriptionWordEfficiencyAction';

/**
 * Panel header actions: search toggle first, then sync / word-efficiency, edit last.
 * The search field itself renders below the header when search is open.
 */
export function TranscriptionToolbar() {
  return (
    <Box sx={{ display: 'flex', flexShrink: 0, alignItems: 'center', gap: 0.5 }}>
      <TranscriptionSearchToggleAction />
      <TranscriptionSyncAction />
      <TranscriptionWordEfficiencyAction />
      <TranscriptionEditModeAction />
    </Box>
  );
}
